/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Box, Theme, Typography, useTheme } from "@mui/material";
import React from "react";
// import paymentLogo from "../../assets/images/payments.png";
import { Colors } from "../../constants/color";
import { staticData } from "../../data/staticData";
// import { SiteDetail as DescriptionProps } from '../../types/site_details/site_details.type';
// import { useFetch } from "../../utils/useFetch.utils";

function Description(): JSX.Element {
  const theme: Theme = useTheme();
  return (
    <Box
      sx={{
        width: { xs: "100%", sm: "70%", md: "321px", lg: "34%", xl: "32%" },
        margin: { xs: "0" },
      }}
    >
      <Box
        sx={{
          width: { xs: "100%" },
          margin: { xs: theme.spacing(0, 0, 2, 0), sm: theme.spacing(0, 0, 3, 0) },
          display: "flex",
          flexDirection: { xs: "column" },
        }}
      >
        {staticData.siteProfile.logo[1].src.length !== 0 ? (<Box
          component="img"
          src={staticData.siteProfile.logo[1].src}
          alt={staticData.siteProfile.logo[1].name}
          sx={{
            width: { xs: "150px" },
          }}
        />) : <Typography variant="h6">{staticData.siteProfile.name}</Typography>}
      </Box>
      <Box
        sx={{
          width: { xs: "100%" },
          color: Colors.boulder,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: "14px" },
            whiteSpace: "pre-line"
          }}
        >
          {staticData.siteProfile.description.split(",")[0]}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px" },
            whiteSpace: "pre-line"
          }}
        >
          {staticData.siteProfile.description.split(",")[1]}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: "14px" },
            whiteSpace: "pre-line"
          }}
        >
          {staticData.siteProfile.description.split(",")[2]}
        </Typography>
        <Box
          sx={{
            marginTop: theme.spacing(1.5),
          }}
        >
          <Typography>{staticData.siteProfile.address}, {staticData.siteProfile.area_code}</Typography>
          <Typography>{staticData.siteProfile.state}, {staticData.siteProfile.country}</Typography>
          {/* <Typography>{staticData.siteProfile.address}</Typography> */}
        </Box>
      </Box>
      {/**
       * contacts details
       */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          margin: { xs: theme.spacing(4, 0, 4, 0) },
          justifyContent: { xs: "flex-start", sm: "space-between" },
        }}
      >
        <Box
          sx={{
            width: { xs: "auto" },
            marginBottom: { xs: theme.spacing(1), sm: 0 },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "13px" },
              color: Colors.boulder,
            }}
          >
            Got Questions? Call us 24/7
          </Typography>
          <Typography
            component="a"
            href={`tel:${staticData.siteProfile.phoneNo}`}
            sx={{
              fontSize: { xs: "20px" },
              color: Colors.fallow,
              textDecoration: "none",
              "&:hover": {
                cursor: "pointer",
              },
            }}
          >
            {staticData.siteProfile.phoneNo}
          </Typography>
        </Box>
        {/**
         * payment method
         */}
        {/* <Box
          sx={{
            width: { xs: "auto" },
            padding: { xs: "0", sm: theme.spacing(0, 1) },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "13px" },
              color: Colors.boulder,
            }}
          >
            Payment Method
          </Typography>
          <Box
            sx={{
              marginTop: theme.spacing(1),
            }}
          >
            <Box
              component="img"
              src={paymentLogo}
              sx={{
                width: { xs: "70%", sm: "90%", md: "100%" },
                height: { xs: "auto" },
              }}
            />
          </Box>
        </Box> */}
      </Box>
    </Box>
  );
};

export default Description;
